<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav justify-content-center dashboard-footer-nav">
        <li class="nav-item">
          <span class="nav-link footer-brand">{{ storeName }}</span>
        </li>
        <li
          class="nav-item"
          v-for="(link, index) in orderedFooterLinks"
          :key="'content-footer-link-' + index"
        >
          <a
            :href="link.url"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            {{ link.name }}
          </a>
        </li>
      </ul>
      <div class="copyright text-center">
        {{ footerBranding.label }} &nbsp; <i class="tim-icons icon-heart-2"></i> &amp;
        <a v-if="footerBranding.productUrl" :href="footerBranding.productUrl" target="_blank" rel="noopener">{{ footerBranding.productName }}</a>
        <span v-else>{{ footerBranding.productName }}</span>
        &bull;
        <a v-if="footerBranding.authorUrl" :href="footerBranding.authorUrl" target="_blank" rel="noopener">{{ footerBranding.authorName }}</a>
        <span v-else>{{ footerBranding.authorName }}</span>
        &copy; {{ year }}.
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  computed: {
    ...mapGetters(['getResources']),
    storeName() {
      return (this.getResources && this.getResources.store) ? this.getResources.store : 'ERP Store';
    },
    footerLinks() {
      const links = (this.getResources && Array.isArray(this.getResources.footerLinks))
        ? this.getResources.footerLinks
        : [];
      return links.filter(link => {
        const name = (link && link.name) ? String(link.name).trim() : '';
        const url = (link && link.url) ? String(link.url).trim() : '';
        return name && /^https:\/\//i.test(url);
      });
    },
    orderedFooterLinks() {
      const rankLink = (link) => {
        const haystack = `${(link && link.name) || ''} ${(link && link.url) || ''}`.toLowerCase();
        if (haystack.includes('about')) return 1;
        if (haystack.includes('contact')) return 2;
        if (haystack.includes('term') || haystack.includes('service')) return 3;
        if (haystack.includes('privacy')) return 4;
        if (haystack.includes('refund')) return 5;
        return 100;
      };

      return this.footerLinks
        .map((link, index) => ({ link, index, rank: rankLink(link) }))
        .sort((a, b) => (a.rank - b.rank) || (a.index - b.index))
        .map(item => item.link);
    },
    footerBranding() {
      const raw = (this.getResources && this.getResources.footerBranding)
        ? this.getResources.footerBranding
        : {};
      const productUrl = (raw && raw.productUrl) ? String(raw.productUrl).trim() : '';
      const authorUrl = (raw && raw.authorUrl) ? String(raw.authorUrl).trim() : '';
      return {
        label: (raw && raw.label) ? String(raw.label).trim() : this.$t('Powered by'),
        productName: (raw && raw.productName) ? String(raw.productName).trim() : this.$t('ERP Store'),
        productUrl: /^https:\/\//i.test(productUrl) ? productUrl : '',
        authorName: (raw && raw.authorName) ? String(raw.authorName).trim() : this.$t('MrZaKaRiA'),
        authorUrl: /^https:\/\//i.test(authorUrl) ? authorUrl : ''
      };
    }
  }
};
</script>
<style scoped>
.footer-brand {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  margin-bottom: 0;
}

.white-content .footer-brand {
  color: #344675;
}

.nav {
  flex-wrap: wrap;
}

.copyright {
  margin-top: 15px;
}

@media (max-width: 767.98px) {
  .footer {
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 18px;
    padding-bottom: calc(18px + env(safe-area-inset-bottom));
  }

  .dashboard-footer-nav {
    display: grid;
    float: none;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px 4px;
    width: 100%;
    margin: 0 0 10px;
    padding: 0;
    list-style: none;
  }

  .dashboard-footer-nav .nav-item {
    width: auto;
    min-width: 0;
    margin: 0;
  }

  .dashboard-footer-nav .nav-link {
    display: block;
    width: 100%;
    padding: 4px 6px;
    text-align: center;
    white-space: normal;
    line-height: 1.2;
    font-size: 0.82rem;
  }

  .footer-brand {
    font-size: 0.82rem;
  }

  .copyright {
    text-align: center;
    margin-top: 10px;
    line-height: 1.5;
  }
}
</style>
